export const CompanyTypes = {
    GET_COMPANIES:'GET_COMPANIES',
    ADD_COMPANY:'ADD_COMPANY'
}